import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { AssistanceAttachment, AssistanceAttachmentsRole } from '../../models/assistance-attachment.model'
import { FeathersService } from '../feathers.service'

@Injectable({
  providedIn: 'root',
})
export class AssistanceAttachmentsService {
  private readonly feathers = inject(FeathersService)

  /** Documents attached to the given assistance. */
  find(assistanceId: number, role: AssistanceAttachmentsRole): Observable<AssistanceAttachment[]> {
    return this.feathers.find(AssistanceAttachment, { assistanceId, role }).pipe(
      map((items) => [...items].filter((a) => a.assistanceId === assistanceId).sort(AssistanceAttachment.sortByName)),
    )
  }

  /** Documents of the assistance's client that are not attached to the assistance yet (coordinator only). */
  findAvailable(assistanceId: number): Observable<AssistanceAttachment[]> {
    return this.feathers.find(AssistanceAttachment, { assistanceId, role: 'coordinator', scope: 'available' }).pipe(map((items) => [...items].sort(AssistanceAttachment.sortByName)))
  }

  /** Attaches an existing client document to the assistance. */
  attachExisting(assistanceId: number, documentId: number): Promise<AssistanceAttachment> {
    return this.feathers.createWithFactory(AssistanceAttachment, { assistanceId, documentId })
  }

  /** Creates a client document from an uploaded file and attaches it to the assistance. */
  attachNew(assistanceId: number, name: string, url: string, mimeType?: string): Promise<AssistanceAttachment> {
    return this.feathers.createWithFactory(AssistanceAttachment, { assistanceId, name, url, mimeType })
  }

  /** Detaches the attachment from the assistance (the document itself is kept). */
  async remove(attachmentId: number): Promise<AssistanceAttachment> {
    return this.feathers.removeById(AssistanceAttachment.serviceName, attachmentId)
  }
}
